var _rect, _circle, _circle2, _path, _path2, _path3, _circle3, _circle4, _path4, _circle5, _circle6, _ellipse, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _ellipse2, _ellipse3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle14, _g, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#d9c4a0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#ddcbab",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 17,
    r: 9,
    fill: "#d6d6de"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#b79ad3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124L70 88C66 92 54 92 50 88Z",
    fill: "#f4eee0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124M70 88L60 124",
    stroke: "#927ba8",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 102,
    r: 1.5,
    fill: "#927ba8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 112,
    r: 1.5,
    fill: "#927ba8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d4b090"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f1c8a4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 92,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 96,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 99,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 99,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 96,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 92,
    r: 2,
    fill: "#f8f4ec",
    stroke: "#d9d2c2",
    strokeWidth: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bb9c7f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#d6d6de",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#d6d6de",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50C35 29 48 22 60 22S85 29 82 50C78 41 71 35 60 35S42 41 38 50Z",
    fill: "#d6d6de"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 17,
    r: 9,
    fill: "#d6d6de"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0.18,
    stroke: "#3b3b4a",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 54,
    r: 7.5
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 53Q60 51.5 61.5 53M43.5 53L38 51M76.5 53L82 51",
    stroke: "#3b3b4a",
    strokeWidth: 2,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait3);
export default __webpack_public_path__ + "static/media/player-portrait-3.d6b7544781f9e7c18c013da5d313103e.svg";
export { ForwardRef as ReactComponent };